import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import { useDismissNotificaiton, useGetNotificationByType } from '@/queries/notification.queries';
import { NotificationType } from '@/repositories/notification.repository';
import { useToast } from '@cmpsr/components';
import { useEffect, useState } from 'react';
import { AssessmentReminderStatus } from './types';

export default function useCompletedAssessmentController() {
  const { data: assessmentData } = useGetNotificationByType(NotificationType.RiskAssessment);
  const uploadDismissAssessment = useDismissNotificaiton(assessmentData?.id || '0');
  const toast = useToast();

  const { dismissedAt }: { dismissedAt: Date | null } = assessmentData ?? {
    dismissedAt: new Date(),
  };

  const status = dismissedAt !== null ? AssessmentReminderStatus.dismissed : AssessmentReminderStatus.displayed;

  const [assessmentStatus, setAssessmentStatus] = useState<AssessmentReminderStatus>(AssessmentReminderStatus[status]);

  useEffect(() => setAssessmentStatus(AssessmentReminderStatus[status]), [status]);

  const dismissBanner = async () => {
    try {
      await uploadDismissAssessment.mutateAsync();
      setAssessmentStatus(AssessmentReminderStatus.dismissed);
    } catch (error: any) {
      console.error(error);
      toast({
        ...TOAST_DEFAULT_OPTIONS,
        title: `Error ${error.response?.data?.statusCode ?? ''}`,
        description: error.response?.data?.message ?? error.message,
        status: 'error',
      });
    }
  };

  return {
    assessmentStatus,
    dismissBanner,
  };
}
